module.exports = __webpack_public_path__ + "img/logo1.d51cfe7a.png";